import { createContext, ReactNode, useContext } from 'react';
import { useMsal } from "@azure/msal-react";
import { tokenRequest } from "../Auth/authConfig";
import axios from 'axios';

type APIContextType = {
    apiFetch: <T = any>(
        endpoint: string,
        method?: 'GET' | 'POST' | 'PUT' | 'DELETE',
        data?: any,
        transform?: (json: any) => T
    ) => Promise<T | null>;
};

export const APIContext = createContext<APIContextType>({
    apiFetch: async () => { throw new Error("Not initialized"); },
});

export const APIProvider = ({ children }: { children: ReactNode }) => {
    const { instance, accounts } = useMsal();

    const apiClient = axios.create({
        baseURL: process.env.REACT_APP_OPALITE_API_URI,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    apiClient.interceptors.request.use(async (config) => {
        const token = await getAccessToken();
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const getAccessToken = async () => {
        if (!accounts[0]) throw new Error("No active account");
        const result = await instance.acquireTokenSilent({
            ...tokenRequest,
            account: accounts[0],
        });
        return result.accessToken;
    };


    const apiFetch = async <T = any>(
        endpoint: string,
        method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
        data?: any,
        transform?: (json: any) => T
    ): Promise<T | null> => {

        try {
            const response = await apiClient.request({
                url: endpoint,
                method,
                data,
            });

            return transform ? transform(response.data) : response.data as T;

        } catch (error) {
            return null;
        }
    };

    return (
        <APIContext.Provider value={{ apiFetch }}>
            {children}
        </APIContext.Provider>
    );
};

export const useAPIContext = () => useContext(APIContext);